/* ==========================================================================
   KEFIT — Search Overlay logic
   Self-contained. Hooks into the EXISTING .kefit-search__input elements
   (desktop + mobile) without any change to kefit-header.liquid markup.
   ========================================================================== */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var overlay = document.querySelector('[data-kefit-search-overlay]');
    if (!overlay) return;

    var overlayInput = overlay.querySelector('[data-kefit-search-overlay-input]');
    var closeBtn = overlay.querySelector('[data-kefit-search-overlay-close]');
    var triggers = document.querySelectorAll('.kefit-search__input');
    var lastFocused = null;

    function openOverlay(prefill) {
      lastFocused = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('kefit-search-overlay-lock');
      if (typeof prefill === 'string' && prefill !== '') {
        overlayInput.value = prefill;
      }
      window.setTimeout(function () { overlayInput.focus(); }, 60);
      document.dispatchEvent(new CustomEvent('kefit:search:opened', { detail: { prefill: prefill } }));
    }

    function closeOverlay() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('kefit-search-overlay-lock');
      if (lastFocused && typeof lastFocused.blur === 'function') lastFocused.blur();
      document.dispatchEvent(new CustomEvent('kefit:search:closed'));
    }

    triggers.forEach(function (input) {
      input.addEventListener('focus', function (e) {
        e.target.blur();
        openOverlay(e.target.value);
      });
      input.addEventListener('click', function (e) {
        e.preventDefault();
        e.target.blur();
        openOverlay(e.target.value);
      });
    });

    var submitButtons = document.querySelectorAll('.kefit-search__submit');
    submitButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var form = btn.closest('.kefit-search__form');
        var input = form ? form.querySelector('.kefit-search__input') : null;
        openOverlay(input ? input.value : '');
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeOverlay);

    document.addEventListener('keydown', function (e) {
      if (overlay.classList.contains('is-open') && (e.key === 'Escape' || e.key === 'Esc')) {
        closeOverlay();
      }
    });

    window.KefitSearchOverlay = {
      open: openOverlay,
      close: closeOverlay,
      isOpen: function () { return overlay.classList.contains('is-open'); }
    };
  });
})();